import { defineMessages } from "react-intl";

const ManageLabourerPageLabels = defineMessages({
    phone: {
        id: "cmis-lab-details-label.phone",
        defaultMessage: "Contact number",
        description: "Contact number label",
    },
    email: {
        id: "cmis-lab-details-label.email",
        defaultMessage: "Email",
        description: "Email label",
    },
    skills: {
        id: "cmis-lab-details-label.skills",
        defaultMessage: "Skills",
        description: "Skills label",
    },
    contracts: {
        id: "cmis-lab-details-label.contract-name",
        defaultMessage: "Contract Name(s)",
        description: "contract names label",
    },
    username: {
        id: "cmis-lab-details-label.username",
        defaultMessage: "Username",
        description: "Username label",
    },
    notes: {
        id: "cmis-lab-details-label.notes",
        defaultMessage: "Notes",
        description: "notes label",
    },
    firstname: {
        id: "cmis-lab-details-label.firstname",
        defaultMessage: "First Name",
        description: "firstname label",
    },
    name: {
        id: "cmis-lab-details-label.name",
        defaultMessage: "Name",
        description: "name label",
    },
    lastname: {
        id: "cmis-lab-details-label.lastname",
        defaultMessage: "Last Name",
        description: "lastname label",
    },
    btncreateuser: {
        id: "button.create-user",
        defaultMessage: "Create User",
        description: "button Create label",
    },
    btnsavechanges: {
        id: "button.save-changes",
        defaultMessage: "Save Changes",
        description: "button save label",
    },
    linkbtneditprofile: {
        id: "button-link.edit-profile",
        defaultMessage: "Edit Profile",
        description: "button link edit label",
    },
    linkbtnback: {
        id: "button-link.back",
        defaultMessage: "Back",
        description: "button link back label",
    },
    linkbtndeactivateprofile: {
        id: "button-link.deactivate-profile",
        defaultMessage: "Deactivate Profile",
        description: "button link deactivate label",
    },
    drawercreateformtitle: {
        id: "cmis-mag-lab-drawer-title.create",
        defaultMessage: "Create User",
        description: "drawer create user label",
    },
    drawereditformtitle: {
        id: "cmis-mag-lab-drawer-title.edit",
        defaultMessage: "Edit User",
        description: "drawer edit user label",
    },
    maintitle: {
        id: "cmis-mag-lab.main.title",
        defaultMessage: "Manage Labourer",
        description: "Manage Labourer page main title",
    },
    sidepanelfilterlabel: {
        id: "cmis-mag-lab-side-panel.filter",
        defaultMessage: "Deactivate Profile",
        description: "button link deactivate label",
    },
});

let viewFields = [
    {
        label: ManageLabourerPageLabels.phone,
        value: "",
        type: "phone",
        key: "phone",
    },
    {
        label: ManageLabourerPageLabels.username,
        value: "",
        type: "text",
        key: "userName",
    },
    {
        label: ManageLabourerPageLabels.email,
        value: "",
        type: "text",
        key: "email",
    },
    {
        label: ManageLabourerPageLabels.skills,
        value: "",
        type: "text",
        key: "skills",
    },
    {
        label: ManageLabourerPageLabels.contracts,
        value: "",
        type: "text",
        key: "contracts",
    },
    {
        label: ManageLabourerPageLabels.notes,
        value: "",
        type: "text",
        key: "notes",
    },
];

let editFields = [
    {
        label: ManageLabourerPageLabels.firstname,
        value: "",
        type: "text",
        key: "firstName",
        required: true,
        isError: false,
        errorMessage: "",
    },
    {
        label: ManageLabourerPageLabels.lastname,
        value: "",
        type: "text",
        key: "lastName",
        required: true,
        isError: false,
        errorMessage: "",
    },
    {
        label: ManageLabourerPageLabels.phone,
        value: "",
        type: "phone",
        key: "phone",
        required: false,
        isError: false,
        errorMessage: "",
    },
    {
        label: ManageLabourerPageLabels.email,
        value: "",
        type: "text",
        key: "email",
        required: true,
        isError: false,
        errorMessage: "",
    },
    {
        label: ManageLabourerPageLabels.username,
        value: "",
        type: "text",
        key: "userName",
        required: true,
        isError: false,
        errorMessage: "",
    },
    {
        label: ManageLabourerPageLabels.skills,
        value: "",
        type: "skillCheckList",
        key: "skills",
        required: false,
        isError: false,
        errorMessage: "",
    },
    {
        label: ManageLabourerPageLabels.contracts,
        value: "",
        type: "contractCheckList",
        key: "contracts",
        required: false,
        isError: false,
        errorMessage: "",
    },
    {
        label: ManageLabourerPageLabels.notes,
        value: "",
        type: "textarea",
        key: "notes",
        required: false,
        isError: false,
        errorMessage: "",
    },
];
export const ManageLabourerPageFields = {
    editFields: editFields,
    viewFields: viewFields,
};
